import { useEffect } from "react";
import "../styles/contact-page.css";
export default function ContactPage() {
  async function handleSubmit(e) {
    e.preventDefault();
    const successMessage = document.getElementById("success-message");
    const contactForm = document.querySelector(".contact-form");
    const formData = new FormData(e.target);
    const sendBtn = document.getElementById("send-btn");
    sendBtn.textContent = "Sending...";
    sendBtn.disabled = true;

    contactForm.classList.toggle("off", true);
    successMessage.classList.toggle("on", true);
    document.getElementById("load-icon-wrapper").classList.toggle("on", true);
    await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
      method: "POST",
      body: formData, // 🔥 this is the key
    }).then((res) => {
      contactForm.classList.toggle("off", true);
      successMessage.classList.toggle("on", true);
      document
        .getElementById("load-icon-wrapper")
        .classList.toggle("on", false);
      console.log(res.json());
    });
  }
  function handleChange() {
    const rangeInput = document.getElementById("range");
    const rangeValue = document.getElementById("range-value");
    rangeValue.textContent = `ETB ${Number(rangeInput.value) + 5}000 - ETB ${Number(rangeInput.value) + 10}000`;
    if (rangeInput.value === "0") {
      rangeValue.textContent = "Less than ETB 5000";
    }
    if (rangeInput.value >= 99) {
      rangeValue.textContent = "More than ETB 110,000";
    }
    console.log(rangeInput.value);
  }
  useEffect(() => {
    const navIcons = document.querySelectorAll(".icon-wrapper");
    navIcons.forEach((icon) => {
      icon.classList.remove("active");
    });
    const selectedIcon = document.getElementById("Contact-icon");
    if (selectedIcon) {
      selectedIcon.classList.add("active");
    }
    document.title = "amantes30 | Contact";
  }, []);
  return (
    <div>
      <section className="hero">
        <h1 className="hero-text">Contact Us</h1>
        <p className="hero-desc">
          If you have any questions or need further information, feel free to
          reach out to me.
        </p>
      </section>
      <section className="contact-form">
        <h2 className="gc-text">Get in Touch</h2>
        <form id="contact-form" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name">
              Name: <sup>*</sup>
            </label>
            <input type="text" id="name" name="name" required />
          </div>
          <div>
            <label htmlFor="phone">
              Phone Number: <sup>*</sup>
            </label>
            <input
              placeholder="Include country code"
              type="tel"
              id="phone"
              name="phone"
              required
            />
          </div>
          <div>
            <label htmlFor="email">
              Email: <sup>*</sup>
            </label>
            <input type="email" id="email" name="email" required />
          </div>
          <div>
            <label htmlFor="telegram_id">Telegram ID:</label>
            <input
              placeholder="@"
              type="text"
              id="telegram_id"
              name="telegram_id"
            />
          </div>
          <div>
            <label htmlFor="subject">
              Subject: <sup>*</sup>
            </label>
            <input
              placeholder="Type of Software | Problem topic"
              type="text"
              id="subject"
              name="subject"
              required
            />
          </div>
          <div>
            <label htmlFor="message">
              Message: <sup>*</sup>
            </label>
            <textarea
              placeholder="Describe Your Needs"
              id="message"
              name="message"
              required
            ></textarea>
          </div>
          <div>
            <label htmlFor="range">
              Budget Range: <span id="range-value"></span>
            </label>

            <input
              type="range"
              id="range"
              name="range"
              onChange={handleChange}
            />
          </div>
          <div>
            <label htmlFor="file">
              Supplementary document (Project Proposal):
            </label>
            <input
              type="file"
              id="file"
              name="file"
              accept="image/png, image/jpeg, .doc, .docx, .xml, .pdf, .ppt"
            />
          </div>
          <button className="p-btn" type="submit" id="send-btn">
            Send Message
          </button>
        </form>
      </section>
      <section id="success-message">
        <h2 className="gc-text">
          Your message has been successfully sent, please check your email
        </h2>
      </section>
    </div>
  );
}
